import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Campagne } from '../models/campagnes';


type SliceModel = Campagne;
const sliceName: string = 'campagnes';

const currRequests: Set<ModelId> = new Set;

export const fetchCampagne = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const campagneAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id,
    sortComparer: (a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
});
export const campagneSlice = createSlice({
    name: sliceName,
    initialState: campagneAdapter.getInitialState(),
    reducers: {
        addMany: campagneAdapter.addMany,
        addOne: campagneAdapter.addOne,
        updateMany: campagneAdapter.updateMany,
        updateOne: campagneAdapter.updateOne,
        upsertOne: campagneAdapter.upsertOne,
        upsertMany: campagneAdapter.upsertMany,
        removeOne: campagneAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchCampagne.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                campagneAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
